export default __webpack_public_path__ + "static/media/JFResumeHeader.5f78e71e.png";